var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsernew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2026 9.2901C8.11927 9.28177 8.01927 9.28177 7.9276 9.2901C5.94427 9.22344 4.36927 7.59844 4.36927 5.59844C4.36927 3.55677 6.01927 1.89844 8.06927 1.89844C10.1109 1.89844 11.7693 3.55677 11.7693 5.59844C11.7609 7.59844 10.1859 9.22344 8.2026 9.2901Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2443 3.5651C15.8609 3.5651 17.1609 4.87344 17.1609 6.48177C17.1609 8.05677 15.9109 9.3401 14.3526 9.39844C14.2859 9.3901 14.2109 9.3901 14.1359 9.39844",
    fill: "white",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.03594 12.3651C2.01927 13.7151 2.01927 15.9151 4.03594 17.2568C6.3276 18.7901 10.0859 18.7901 12.3776 17.2568C14.3943 15.9068 14.3943 13.7068 12.3776 12.3651C10.0943 10.8401 6.33594 10.8401 4.03594 12.3651Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8526 16.8984C16.4526 16.7734 17.0193 16.5318 17.4859 16.1734C18.7859 15.1984 18.7859 13.5901 17.4859 12.6151C17.0276 12.2651 16.4693 12.0318 15.8776 11.8984",
    fill: "white",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2443 3.5651C15.8609 3.5651 17.1609 4.87344 17.1609 6.48177C17.1609 8.05677 15.9109 9.3401 14.3526 9.39844C14.2859 9.3901 14.2109 9.3901 14.1359 9.39844M15.8526 16.8984C16.4526 16.7734 17.0193 16.5318 17.4859 16.1734C18.7859 15.1984 18.7859 13.5901 17.4859 12.6151C17.0276 12.2651 16.4693 12.0318 15.8776 11.8984M8.2026 9.2901C8.11927 9.28177 8.01927 9.28177 7.9276 9.2901C5.94427 9.22344 4.36927 7.59844 4.36927 5.59844C4.36927 3.55677 6.01927 1.89844 8.06927 1.89844C10.1109 1.89844 11.7693 3.55677 11.7693 5.59844C11.7609 7.59844 10.1859 9.22344 8.2026 9.2901ZM4.03594 12.3651C2.01927 13.7151 2.01927 15.9151 4.03594 17.2568C6.3276 18.7901 10.0859 18.7901 12.3776 17.2568C14.3943 15.9068 14.3943 13.7068 12.3776 12.3651C10.0943 10.8401 6.33594 10.8401 4.03594 12.3651Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsernew);
export default __webpack_public_path__ + "static/media/usernew.5d18928658f5da1a59d2eede58f2ac69.svg";
export { ForwardRef as ReactComponent };